import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../shared/colors";

const useStyles = makeStyles( theme => ({

    requiredInfo:{
        display: 'flex',
        justifyContent: 'flex-start',
        paddingBottom: '2rem',
        [theme.breakpoints.down('xs')]:{
            fontSize: '0.8rem',
        }
    },
    searchButton:{
        [theme.breakpoints.up(600)]:{
            paddingLeft: '16rem',
        },
        display: 'flex',
        justifyContent: 'center'
    },
    backBar:{
        marginTop: '2rem',
        marginLeft: '2rem'
    },
    pageHeader:{
        margin: '2rem',
        fontWeight: 'bold',
        color: colors.magellanDarkBlue,
        [theme.breakpoints.down('xs')]:{
            fontSize: '0.7rem'
        }
    },
    inquiryResultsLoading:{
        display: 'flex',
        justifyContent: 'center'
    },
    inquiryResultsTable:{
        padding: theme.spacing(2)
    },
    advSearchLink: {
        color: colors.magellanPurple,
        cursor: 'pointer',
        '&:hover': {
            color: colors.magellanPurple,
            cursor: 'pointer'
        }
    },
    formWrapper:{
        marginLeft: '5vw',
        marginBottom: '10vh',
        marginTop: '5vh',
        [theme.breakpoints.down('sm')]:{
            marginLeft: '30vw',
        }
    },
    providerNPILabel: {
        fontWeight: 'bold',
        padding: '1rem'
    },
    providerNPILabelWrapper: {
        maxWidth: '300px',
    },
    providerNPIValue: {
        paddingTop: '1.5vh',
        [theme.breakpoints.down('xs')]:{
            paddingTop: '0%',
            paddingLeft: '3%'
        }
    },
    universalVerbiage: {
        fontSize: '1.2rem',
        marginLeft: '5vw'

    },
    formVerbiage: {
        fontSize: '1.2rem',
        marginLeft: '5vw',
        marginTop: '1.5vh'

    },
}));

export default useStyles;
